type AuthType = Record<'authed' | 'noAuth', 1 | 0>

export const AUTH_TYPE: AuthType = {
  authed: 1,
  noAuth: 0,
}
